<template>
  <div class="footer">
    <div class="section back-sign">
      <div class="copy-info flex-col">
        <h3>
          International Centre For Engineering Education under the auspices of
          UNESCO (ICEE)
        </h3>
        <div>
          Address：4F, Wennan Building, Tsinghua University, Haidian District,
          Beijing, P.R.China, 100084
        </div>
        <div>Tel： 86(10)-62791751</div>
        <div>E-mail： icee@tsinghua.edu.cn</div>
        <div class="flex-row items-center">
          Copyright © 2026 ICEE. All rights reserved
          <img
            src="../assets/images/icon-p.png"
            class="copy-icon"
          />京ICP备14021735号-4
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watchEffect } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "Footer",
  setup(props, ctx) {
    let links = ref(true);
    watchEffect(() => {
      links.value = ctx.root.$route.path === "/" ? true : false;
    });
    return {
      links,
    };
  },
});
</script>
<style scoped lang="scss">
.footer {
  background-color: #838383;
  .back-sign {
    background-image: url("../assets/images/sign.png");
    background-repeat: no-repeat;
    background-position: right center;
    background-size: auto 100%;
    padding-bottom: 30px;
  }
  .freind-list {
    a {
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #e4e4e4;
      line-height: 22px;
      margin: 10px 40px 10px 0;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .copy-info {
    padding-top: 24px;
    font-size: 12px;
    font-weight: 400;
    color: #bdbdbd;
    line-height: 21px;
    line-height: 22px;
    h3 {
      height: 21px;
      font-size: 15px;
      color: #bdbdbd;
      line-height: 21px;
      margin-bottom: 10px;
    }
    .copy-icon {
      margin: 0 2px 0 20px;
    }
  }
}
</style>
